module.exports = __webpack_public_path__ + "img/2.d33b0611.png";